import React, { useState } from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import GridItem from "../../GridItem/GridItem";
import Paper from "@mui/material/Paper";
import "../../../App.css";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useParams } from "react-router-dom";
import { getUsageDetailsExcel } from "../../../services/FortificationService";
import useTranslatewrapper from "../../../components/useTranslateWrapper";

const Usage = (props) => {
  const { translate } = useTranslatewrapper();
  const { rowData, columnDefs } = props;
  const [loader, setLoader] = React.useState(false);

  const [gridApi, setGridApi] = useState(null);

  const RowSelectionType = "single";
  const getParams = useParams();

  const defaultColDef = {
    flex: 1,
    minWidth: 170,
    floatingFilter: false,
    resizable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };

  function onGridReady(params) {
    setGridApi(params.api);
  }

  const getExcel = ()=>{
    getUsageDetailsExcel(getParams.categoryId, getParams.id, getParams.type, props.batchNo)
  }

  return (
    <div>
      {loader ? (
        <Box className="main-content-overlay" sx={{ height: "100vh" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box component={Paper} className="form-div " >
          {/* <div>
        <a
          onClick={getExcel}
          href="javascript:void(0)"
        >
          <span style={{ fontSize: "1rem" }}>{translate('download')}</span>
          <FileDownloadOutlinedIcon sx={{ fontSize: "1.2rem" }} m={1} />
        </a>
      </div> */}
          <div>
            <GridItem
              onGridReady={onGridReady}
              rowData={rowData}
              rowSelection={RowSelectionType}
              columnDefs={columnDefs}
              pagination={false}
              defaultColDef={defaultColDef}
              showDownloadButton={true}
              title={props.title}
            />
          </div>
        </Box>
      )}
    </div>
  );
};

export default Usage;
